import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Tag } from "lucide-react";

/** Lightweight alt-text-only editor for an existing gallery photo (crop happens at upload time now). */
export const AltTextDialog = ({ open, onOpenChange, image, onSave }) => {
  const [alt, setAlt] = useState("");

  useEffect(() => {
    if (open) setAlt(image?.alt || "");
  }, [open, image]);

  if (!image) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-[var(--bg-secondary)] border-[var(--border-default)] text-white">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <Tag size={18} className="text-[var(--brand-primary)]" /> Alt Text
          </DialogTitle>
        </DialogHeader>
        <img
          src={image.type === "video" ? image.poster : image.src}
          alt=""
          className="w-full aspect-[4/3] object-cover border border-[var(--border-default)]"
        />
        <label className="block mt-2">
          <span className="text-xs font-mono uppercase tracking-widest text-white/60">Alt Text (for SEO &amp; accessibility)</span>
          <input
            data-testid="alt-text-input"
            value={alt}
            onChange={(e) => setAlt(e.target.value)}
            placeholder="e.g. Toyota Hilux 2026 with Bushtech canopy fitted, rear tailgate view"
            className="w-full mt-1.5 bg-[var(--bg-main)] border border-[var(--border-default)] px-3 py-2 text-white focus:border-[var(--brand-primary)] outline-none"
          />
        </label>
        <DialogFooter>
          <button
            type="button"
            data-testid="alt-text-save"
            onClick={() => { onSave(alt.trim() || null); onOpenChange(false); }}
            className="btn-primary"
          >
            Save
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
